
export default {
  'simplePlaceSearch': {
    'noPlaceFound': 'Aucun lieu trouvé avec le contenu imputé',
    'openSidebarToSeeRouteDetails': 'Ouvrez la barre latérale pour voir les détails de l\'itinéraire',
    'unknownSearchPlaceError': 'Erreur de lieu de recherche inconnue'
  }
}
